<template>
  <section class="flex flex-col gap-4">
    <div
      class="flex gap-2 flex-col flex-1 px-2 py-2 rounded-xl"
      v-for="(p, idx) in players"
      :key="idx"
      :class="[idx % 2 === 0 ? 'bg-[#D388CA]' : 'bg-[#EA96A2]']"
    >
      <div class="flex text-center justify-between items-center">
        <div class="text-primary text-lg font-semibold flex items-center">
          <span v-if="p.name != ''">{{ p.name }}</span><span v-else>Player {{idx + 1}}</span>
          <span v-if="idx == currentPlayerIndex" class="current">Current</span>
        </div>
     
        <div
          :class="idx !== currentPlayerIndex ? 'flex' : 'hidden'"
          class="rounded-full bg-primary px-4 py-2 min-w-[75px] justify-center font-bold"
        >
          {{ p.score }}
        </div>
      </div>

      <div
        class="gap-1 flex-1 items-stretch justify-between"
        :class="idx === currentPlayerIndex ? 'flex' : 'hidden'"
      >
        <span
          v-for="n in 3"
          :key="n"
          class="bg-primary rounded-full px-4 py-2 min-w-[75px] text-center"
        >
          {{ turnScores[idx][n - 1] !== null ? turnScores[idx][n - 1] : '-' }}
        </span>
        <span class="bg-primary rounded-full px-4 py-2 min-w-[75px] text-center font-bold">
          {{ p.score }}
        </span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  players: {
    type: Array,
    default: () => [],
  },

  currentPlayerIndex: {
    type: Number,
    default: 0,
  },
  turnScores: {
    type: Array,
    default: () => [],
  },
});
</script>
